import { MemberType } from '@lucidlink/dto/validation';
export const getCreatedByDisplayName = (createdByMember) => {
    if (!createdByMember) {
        return null;
    }
    if (createdByMember.type === MemberType.USER) {
        return createdByMember.account.user.email;
    }
    return createdByMember.account.serviceAccount.name;
};
export const getCreatedById = (createdByMember) => {
    if (!createdByMember) {
        return null;
    }
    if (createdByMember.type === MemberType.USER) {
        return createdByMember.account.user.id;
    }
    return createdByMember.account.serviceAccount.id;
};
export const getCreatedByInfo = (createdByMember) => {
    if (!createdByMember) {
        return {
            id: null,
            name: null,
            type: null,
        };
    }
    if (createdByMember.type === MemberType.USER) {
        return {
            id: createdByMember.account.user.id,
            name: createdByMember.account.user.email,
            type: createdByMember.type,
        };
    }
    return {
        id: createdByMember.account.serviceAccount.id,
        name: createdByMember.account.serviceAccount.name,
        type: createdByMember.type,
    };
};
